@use '../../assets/styles/variables.scss' as vars;
@use '../../assets/styles/medias.scss' as medias;

.hamburger {
  display: flex;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  background: none;
  border: none;
  padding: 0rem;
  height: 60px;
}

.hamburger__icon {
  position: relative;
  margin-top: 28px;
  width: 60px;
  height: 4px;
  background-color: vars.$white;
  transition: transform 0.3s ease;

  &::before,
  &::after {
    content: '';
    position: absolute;
    width: 60px;
    height: 4px;
    background-color: vars.$white;
    transition: transform 0.3s ease;
    left: 0px;
  }

  &::before {
    transform: translateY(-20px);
  }

  &::after {
    transform: translateY(20px);
  }
}

.hamburger--open .hamburger__icon {
  background-color: vars.$darkblue;
}

.hamburger--open .hamburger__icon::before {
  transform: rotate(45deg);
}

.hamburger--open .hamburger__icon::after {
  transform: rotate(-45deg);
}
